import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Form } from 'react-form';
import TabElement from '../UI/Tabs';
import Dialog from '../UI/Dialog';
import SelectMenu from '../UI/Select';
import TextFields from '../UI/TextFiled';
import ImageUpload from '../UI/ImageUpload';
import imgPlaceholder from '../../assets/img/img-placeholder.png';

class UserMarketing extends Component {
    state = {
        createEmail: false,
        createSMS: false,
        createNotification: false,
        emailSingleView: false,
        smsSingleView: false,
        notificationSingleView: false
    };

    submitCreateNotificationForm = values => {
        this.setState({ createNotification: false });
    };

    submitCreateSmsForm = values => {
        this.setState({ createSMS: false });
    };

    submitCreateEmailForm = values => {
        this.setState({ createEmail: false });
    };

    render() {

        const tabElements = [
            (
                <React.Fragment key='1'>
                    <div className="tab-content">

                        <div className="row flex-center-y justify-between mt-30">
                            <div className="col-xs-9">
                                <h1 className="color-grey">Emails</h1>
                            </div>
                            <div className="col-xs-3 text-right flex justify-end">
                                <button className="no-style min-120 pointer w-600 flex-center-y" onClick={() => this.setState({ createEmail: true })}>
                                    <i className="fa fa-plus-circle mr-5 font-md"></i> Create New Email
                                </button>
                            </div>
                        </div>

                        <div className="table withHover emailsTable mt-30">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Email Heading</th>
                                        <th>Email Body Text</th>
                                        <th>Created Date</th>
                                        <th>Recipient(s)</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td onClick={() => this.setState({ emailSingleView: true })}>Lorem Ipsum</td>
                                    <td onClick={() => this.setState({ emailSingleView: true })}>
                                        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aperiam asperiores aut blanditiis,
                                        delectus dolor, ducimus expedita iste, nam necessitatibus neque nobis odit quo reprehenderit
                                        repudiandae tempore veniam voluptas! Facere, maiores.
                                    </td>
                                    <td onClick={() => this.setState({ emailSingleView: true })}>25.05.19</td>
                                    <td onClick={() => this.setState({ emailSingleView: true })}>All registered users</td>
                                    <td>
                                        <div className="flex-center-y justify-center">
                                            <Link to="#" className="px-10"><i className="fa fa-pencil"></i></Link>
                                            <Link to="#" className="px-10 color-red"><i className="fa fa-trash font-md"></i></Link>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="text-right mt-20">
                            <Link to="" className="flex-align-y font-sm w-800"><i className="fa fa-download mr-10"></i>Download Excel File</Link>
                        </div>
                    </div>
                    <Dialog open={this.state.createEmail} handleClose={ () => this.setState({ createEmail: false }) }>
                        <Form onSubmit={ this.submitCreateEmailForm }>
                            { formApi => (
                                <form onSubmit={formApi.submitForm}>
                                    <div className="popup-title">
                                        <h2>Create New Email</h2>
                                    </div>
                                    <div className="popup-body pt-10">
                                        <ImageUpload/>
                                        <TextFields field="title" label="Email Title"></TextFields>
                                        <div className="text-field my-10">
                                            <label htmlFor="email_text" className="label">Email Body Text</label>
                                            <textarea name="email_text" field="email_text" id="email_text"></textarea>
                                        </div>
                                        <SelectMenu field="type" label="Choose Recepients" menu={[{key: 1, value: 1}, {key: 2, value: 2}]}/>
                                    </div>
                                    <div className="popup-meta flex justify-end">
                                        <button type="button" className="no-style w-600 pointer mx-20" onClick={ () => this.setState({ createEmail: false }) }>Cancel</button>
                                        <button className="btn filled primary min-120">Submit</button>
                                    </div>
                                </form>
                            )}
                        </Form>
                        <button className="no-style close-btn" onClick={ () => this.setState({ createEmail: false }) }>×</button>
                    </Dialog>
                    <Dialog open={this.state.emailSingleView} handleClose={ () => this.setState({ emailSingleView: false }) }>
                        <div className="popup-body">
                            <div className="flex">
                                <div className="image-upload size-md my-20">
                                    <div className="image">
                                        {/* START: Replace this image after upload */}
                                        <img src={ imgPlaceholder } alt="placeholder"/>
                                        {/* END: Replace this image after upload */}
                                    </div>
                                </div>
                                <ul className="ml-50 mt-10 w-700">
                                    <li className="py-15">
                                        <p className="font-sm color-grey50">Email Heading</p>
                                        <p className="color-primary mt-5">Lorem Ipsum</p>
                                    </li>
                                </ul>
                            </div>
                            <ul className="mt-10 w-700">
                                <li className="py-15">
                                    <p className="font-sm color-grey50">Email Body Text</p>
                                    <p className="color-primary mt-5">
                                        Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                                        Asperiores assumenda consequuntur delectus deleniti dignissimos distinctio dolor dolorum
                                        explicabo incidunt molestiae, molestias nobis non pariatur praesentium recusandae sequi suscipit, veritatis vero?
                                    </p>
                                </li>
                                <li className="py-15">
                                    <p className="font-sm color-grey50">Created Date</p>
                                    <p className="color-primary mt-5">25.05.19</p>
                                </li>
                                <li className="py-15">
                                    <p className="font-sm color-grey50">Recipient(s)</p>
                                    <p className="color-primary mt-5">All registered users</p>
                                </li>
                            </ul>
                        </div>
                        <div className="popup-meta text-center">
                            <button className="btn filled primary min-180">Send this email</button>
                        </div>
                        <button className="no-style close-btn" onClick={ () => this.setState({ emailSingleView: false }) }>×</button>
                    </Dialog>
                </React.Fragment>
            ),
            (
                <React.Fragment key='2'>
                    <div className="tab-content">

                        <div className="row flex-center-y justify-between mt-30">
                            <div className="col-xs-9">
                                <h1 className="color-grey">SMS</h1>
                            </div>
                            <div className="col-xs-3 text-right flex justify-end">
                                <button className="no-style min-120 pointer w-600 flex-center-y" onClick={() => this.setState({ createSMS: true })}>
                                    <i className="fa fa-plus-circle mr-5 font-md"></i> Create New SMS
                                </button>
                            </div>
                        </div>

                        <div className="table withHover smsTable mt-30">
                            <table>
                                <thead>
                                <tr>
                                    <th>SMS Heading</th>
                                    <th>SMS Body Text</th>
                                    <th>Created Date</th>
                                    <th>Recipient(s)</th>
                                    <th>Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td onClick={() => this.setState({ smsSingleView: true })}>Lorem Ipsum</td>
                                    <td onClick={() => this.setState({ smsSingleView: true })}>
                                        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aperiam asperiores aut blanditiis,
                                        delectus dolor, ducimus expedita iste, nam necessitatibus neque nobis odit quo reprehenderit
                                        repudiandae tempore veniam voluptas! Facere, maiores.
                                    </td>
                                    <td onClick={() => this.setState({ smsSingleView: true })}>25.05.19</td>
                                    <td onClick={() => this.setState({ smsSingleView: true })}>All registered users</td>
                                    <td>
                                        <div className="flex-center-y justify-center">
                                            <Link to="#" className="px-10"><i className="fa fa-pencil"></i></Link>
                                            <Link to="#" className="px-10 color-red"><i className="fa fa-trash font-md"></i></Link>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <Dialog open={this.state.createSMS} handleClose={ () => this.setState({ createSMS: false }) }>
                        <Form onSubmit={ this.submitCreateSmsForm }>
                            { formApi => (
                                <form onSubmit={formApi.submitForm}>
                                    <div className="popup-title">
                                        <h2>Create New SMS</h2>
                                    </div>
                                    <div className="popup-body">
                                        <TextFields field="sms_title" label="SMS Title"></TextFields>
                                        <div className="text-field my-10">
                                            <label htmlFor="sms_text" className="label">SMS Body Text</label>
                                            <textarea name="sms_text" field="sms_text" id="sms_text"></textarea>
                                        </div>
                                        <SelectMenu field="sms_type" label="Choose Recepients" menu={[{key: 1, value: 1}, {key: 2, value: 2}]}/>
                                    </div>
                                    <div className="popup-meta flex justify-end">
                                        <button className="no-style w-600 pointer mx-20" onClick={ () => this.setState({ createSMS: false }) }>Cancel</button>
                                        <button className="btn filled primary min-120">Submit</button>
                                    </div>
                                </form>
                            )}
                        </Form>
                        <button className="no-style close-btn" onClick={ () => this.setState({ createSMS: false }) }>×</button>
                    </Dialog>
                    <Dialog open={this.state.smsSingleView} handleClose={ () => this.setState({ smsSingleView: false }) }>
                        <div className="popup-body">
                            <ul className="mt-10 w-700">
                                <li className="py-15">
                                    <p className="font-sm color-grey50">SMS Heading</p>
                                    <p className="color-primary mt-5">Lorem Ipsum</p>
                                </li>
                                <li className="py-15">
                                    <p className="font-sm color-grey50">SMS Body Text</p>
                                    <p className="color-primary mt-5">
                                        Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                                        Asperiores assumenda consequuntur delectus deleniti dignissimos distinctio dolor dolorum
                                        explicabo incidunt molestiae, molestias nobis non pariatur praesentium recusandae sequi suscipit, veritatis vero?
                                    </p>
                                </li>
                                <li className="py-15">
                                    <p className="font-sm color-grey50">Created Date</p>
                                    <p className="color-primary mt-5">25.05.19</p>
                                </li>
                                <li className="py-15">
                                    <p className="font-sm color-grey50">Recipient(s)</p>
                                    <p className="color-primary mt-5">All registered users</p>
                                </li>
                            </ul>
                        </div>
                        <div className="popup-meta text-center">
                            <button className="btn filled primary min-180">Send this SMS</button>
                        </div>
                        <button className="no-style close-btn" onClick={ () => this.setState({ smsSingleView: false }) }>×</button>
                    </Dialog>
                </React.Fragment>
            ),
            (
                <React.Fragment key='3'>
                    <div className="tab-content">

                        <div className="row flex-center-y justify-between mt-30">
                            <div className="col-xs-9">
                                <h1 className="color-grey">Push Notifications</h1>
                            </div>
                            <div className="col-xs-3 text-right flex justify-end">
                                <button className="no-style min-120 pointer w-600 flex-center-y" onClick={() => this.setState({ createNotification: true })}>
                                    <i className="fa fa-plus-circle mr-5 font-md"></i> Create New Notifications
                                </button>
                            </div>
                        </div>

                        <div className="table withHover smsTable mt-30">
                            <table>
                                <thead>
                                <tr>
                                    <th>Notification Heading</th>
                                    <th>Notification Body Text</th>
                                    <th>Created Date</th>
                                    <th>Recipient(s)</th>
                                    <th>Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td onClick={() => this.setState({ notificationSingleView: true })}>Lorem Ipsum</td>
                                    <td onClick={() => this.setState({ notificationSingleView: true })}>
                                        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aperiam asperiores aut blanditiis,
                                        delectus dolor, ducimus expedita iste, nam necessitatibus neque nobis odit quo reprehenderit
                                        repudiandae tempore veniam voluptas! Facere, maiores.
                                    </td>
                                    <td onClick={() => this.setState({ notificationSingleView: true })}>25.05.19</td>
                                    <td onClick={() => this.setState({ notificationSingleView: true })}>All registered users</td>
                                    <td>
                                        <div className="flex-center-y justify-center">
                                            <Link to="#" className="px-10"><i className="fa fa-pencil"></i></Link>
                                            <Link to="#" className="px-10 color-red"><i className="fa fa-trash font-md"></i></Link>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </React.Fragment>
            )

        ];

        return (
            <React.Fragment>
                <div className="page-title">
                    <div className="container">
                        <div className="row flex-center-y justify-between">
                            <div className="col-xs-9">
                                <h1 className="color-grey">Marketing</h1>
                            </div>
                            <div className="col-xs-3">
                                <Form onSubmit={ this.submitted }>
                                    { formApi => (
                                        <form onSubmit={formApi.submitForm} className="search">
                                            <TextFields type="text" hintText="Search"/>
                                            <button className="no-style search-btn pointer">
                                                <i className="fa fa-search"></i>
                                            </button>
                                        </form>
                                    )}
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container box py-15">
                    <TabElement labels={['Email', 'SMS', 'Push Notifications']}>
                        { tabElements }
                    </TabElement>
                </div>

                <Dialog open={this.state.createNotification}
                        handleClose={ () => this.setState({ createNotification: false }) } >

                    <Form onSubmit={ this.submitCreateNotificationForm }>
                        { formApi => (
                            <form onSubmit={formApi.submitForm}>
                                <div className="popup-title">
                                    <h2>Create New Notification</h2>
                                </div>
                                <div className="popup-body">
                                    <TextFields field="notification_title" label="Notification Title"></TextFields>
                                    <div className="text-field my-10">
                                        <label htmlFor="sms_text" className="label">Notification Body Text</label>
                                        <textarea  field="notification_text" name="notification_text" id="notification_text"></textarea>
                                    </div>
                                    <SelectMenu field="notification_type" label="Choose Recepients" menu={[{key: 1, value: 1}, {key: 2, value: 2}]}/>
                                </div>
                                <div className="popup-meta flex justify-end">
                                    <button className="no-style w-600 pointer mx-20" onClick={ () => this.setState({ createSMS: false }) }>Cancel</button>
                                    <button className="btn filled primary min-120">Submit</button>
                                </div>
                            </form>
                        )}
                    </Form>
                    <button className="no-style close-btn" onClick={ () => this.setState({ createNotification: false }) }>×</button>
                </Dialog>

                <Dialog open={this.state.notificationSingleView} handleClose={ () => this.setState({ notificationSingleView: false }) }>
                    <div className="popup-body">
                        <div className="flex">
                            <div className="image-upload size-md my-20">
                                <div className="image">
                                    {/* START: Replace this image after upload */}
                                    <img src={ imgPlaceholder } alt="placeholder"/>
                                    {/* END: Replace this image after upload */}
                                </div>
                            </div>
                            <ul className="ml-50 mt-10 w-700">
                                <li className="py-15">
                                    <p className="font-sm color-grey50">Notification Heading</p>
                                    <p className="color-primary mt-5">Lorem Ipsum</p>
                                </li>
                            </ul>
                        </div>
                        <ul className="mt-10 w-700">
                            <li className="py-15">
                                <p className="font-sm color-grey50">Notification Body Text</p>
                                <p className="color-primary mt-5">
                                    Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                                    Asperiores assumenda consequuntur delectus deleniti dignissimos distinctio dolor dolorum
                                    explicabo incidunt molestiae, molestias nobis non pariatur praesentium recusandae sequi suscipit, veritatis vero?
                                </p>
                            </li>
                            <li className="py-15">
                                <p className="font-sm color-grey50">Created Date</p>
                                <p className="color-primary mt-5">25.05.19</p>
                            </li>
                            <li className="py-15">
                                <p className="font-sm color-grey50">Recipient(s)</p>
                                <p className="color-primary mt-5">All registered users</p>
                            </li>
                        </ul>
                    </div>
                    <div className="popup-meta text-center">
                        <button className="btn filled primary min-180">Send this Notification</button>
                    </div>
                    <button className="no-style close-btn" onClick={ () => this.setState({ notificationSingleView: false }) }>×</button>
                </Dialog>

            </React.Fragment>
        );
    }
}

export default UserMarketing;



// WEBPACK FOOTER //
// ./src/components/User-relationship/Marketing.js